var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('toggle-single',{attrs:{"id":"enable-agenda","label-name":"Enabled","toggle-model":_vm.hasNotifications},on:{"toggle-click":_vm.handleToggleClick}}),_c('toggles-form',{attrs:{"data-array":_vm.toggles},on:{"toggles-change":_vm.handleToggleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }